/*
 * This module will be ready to be notified whenever a element is selected in the marquee/galleryModal
 * and display the virtual tour if the selected element correspond to virtual tours.
 */
/* eslint-disable class-methods-use-this */
define(
  'builderShowcaseIframeHandler',[
  ],
  () => {
    'use strict';

    class IframeHandler {
      constructor(configObject) {
        this.config = configObject;
      }

      /**
      * @private
      * replaceSpecialCharactersFromEmbedCode: replaces ASCII codes of a string, in concrete: <, >, '.
      * @param {string} embedCode is the string where we want to replace special characters from.
      */
      replaceSpecialCharactersFromEmbedCode(embedCode) {
        if (!embedCode) {
          return '';
        }

        const replaceableStrings = {
          '&amp;': '',
          'lt;': '<',
          'gt;': '>',
          '#39;': '\'',
          'quot;': '\'',
        };

        const getReplaceableValue = function getReplaceableValue(char) {
          return replaceableStrings[char] || '';
        };

        return embedCode.replace(/&amp;|lt;|gt;|#39;|quot;/g, getReplaceableValue);
      }

      /**
      * @private
      * getEmbededCodeSource: return the embed code src.
      * @param {string} embedCode is the embedCode we need to return as an element.
      */
      getEmbededCodeSource(embedCode) {
        if (!embedCode) {
          return undefined;
        }

        const embedCodeWithoutAsciiCharacters = this.replaceSpecialCharactersFromEmbedCode(embedCode);
        return embedCodeWithoutAsciiCharacters.replace(/.*src='(.*?)'.*/g, '$1');
      }

      /**
       * Method subscribed to OnImageSelected event,
       * this will receive the active image object as input to build and replace the marquee main image.
       * @param {object} data active image object
       */
      update(data) {
        if (!data || !data.Url) {
          const tourContainer = this.config.mainViewer.querySelector('#nhs_TourContainer');
          if (tourContainer) {
            tourContainer.parentElement.removeChild(tourContainer);
          }
          return;
        }

        const containerDiv = document.createElement('DIV');
        const iframe = document.createElement('IFRAME');
        iframe.setAttribute('sandbox', 'allow-same-origin allow-scripts allow-forms');

        let iframeSource = this.getEmbededCodeSource(data.EmbedCode);
        if (!iframeSource) {
          iframeSource = data.Url;
        }

        iframe.src = iframeSource;
        containerDiv.className = 'gallery-box__tour';
        containerDiv.id = 'nhs_TourContainer';
        containerDiv.appendChild(iframe);
        this.config.mainViewer.prepend(containerDiv);
      }
    }

    return IframeHandler;
  }
);

